import React from 'react';
import { Upload, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import axios from 'axios';
import client from '@/lib/feathers';
import styles from './index.module.scss';
import type { RcFile } from 'antd/es/upload/interface';
import type { UploadRequestOption } from 'rc-upload/lib/interface';
import type { Uploads } from '@/types/database/uploads';

interface UploadImageProps {
  imageList: Uploads[];
  updateImgUrl: (imageList: Uploads[]) => void;
}

const UploadImage = ({ imageList, updateImgUrl }: UploadImageProps) => {
  const uploadService = client.service('uploads');

  const uploadFiles = async (dbName: string, file: string | Blob | RcFile) => {
    const formData = new FormData();
    formData.append('files', file);
    const response = await axios.post<Uploads>(
      `/newUploads?type=${dbName}&isConvertPng=false`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          authorization: localStorage.getItem('feathers-jwt'),
        },
      }
    );
    return response;
  };

  const deleteFile = (file) => {
    return uploadService.remove(file.uid);
  };

  const customRequest = async (options: UploadRequestOption) => {
    const { onSuccess, file } = options;
    try {
      const response = await uploadFiles('groupBuying', file);
      if (onSuccess) {
        onSuccess(response.data);
        updateImgUrl([response.data]);
        message.success('圖片上傳成功!');
      }
    } catch (error) {
      message.error('圖片上傳失敗!');
      console.error(error);
    }
  };

  return (
    <Upload
      name="groupBuyingImage"
      listType="picture-card"
      fileList={
        imageList && imageList.length !== 0
          ? [
              {
                uid: imageList[0]._id,
                name: imageList[0].oldName,
                url: imageList[0].showPath,
              },
            ]
          : []
      }
      className={styles.uploadComponent}
      maxCount={1}
      accept="image/*"
      customRequest={customRequest}
      onRemove={async (file) => {
        try {
          await deleteFile(file);
          updateImgUrl([]);
          message.success('圖片已移除!');
        } catch (error) {
          console.error(error);
        }
      }}
    >
      <div>
        <PlusOutlined />
        <div className={styles.uploadImg}>Upload</div>
      </div>
    </Upload>
  );
};

export default UploadImage;
